export default __webpack_public_path__ + "static/media/Gloves of Quilled Darts.e5669c4c.jpg";